import React, { useState, useEffect } from "react";
import CTAButton from "./CTAButton"; // adjust the path if needed

function PromoCTAButton({ plan, createHandleButtonClick }) {
	const [promoCode, setPromoCode] = useState(
		plan?.fields?.promoCodeForThisPlan || "",
	);

	useEffect(() => {
		if (typeof window !== "undefined") {
			const urlParams = new URLSearchParams(window.location.search);
			const codeFromUrl = urlParams.get("code");
			if (codeFromUrl) {
				setPromoCode(codeFromUrl);
			}
		}
	}, [plan]);

	const url = `/buy?id=${plan?.fields?.ctaButtonUrl}endid&rc=${promoCode}endrc`;

	return (
		<CTAButton
			onClick={createHandleButtonClick(plan)}
			url={url}
			ctaButtonColour={plan?.fields?.ctaButtonColour}
			gtmCtaText={plan?.fields?.ctaButtonLabel}
			gtmCtaPosition={plan?.fields?.planName}
		>
			{plan?.fields?.ctaButtonLabel}
		</CTAButton>
	);
}

export default PromoCTAButton;
